import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Check, ChevronRight } from 'lucide-react';
import services from 'services';
import { Doctor, User } from 'models';
import PersonalInfoForm from 'components/forms/doctors/PersonalInfoForm';
import ClinicalDetailsForm from 'components/forms/doctors/ClinicalDetailsForm';
import CredentialsForm from 'components/forms/doctors/CredentialsForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var NewDoctor = function (props) {
    var t = props.translate;
    var navigate = useNavigate();
    var user = useState(function () { return new User(); })[0];
    var doctor = useState(function () { return new Doctor(); })[0];
    var _a = useState(false), disabled = _a[0], setDisabled = _a[1];
    var form = Form.useForm()[0];
    var specializationService = services.specializationService, doctorService = services.doctorService;
    var specializations = specializationService.useSpecializations().data;
    var _b = doctorService.useCreateDoctor(), createDoctor = _b.mutate, requestStatus = _b.status;
    var syncModelsFromForm = function () {
        var _a;
        var values = form.getFieldsValue(true);
        if (values.fullName)
            user.setName(String(values.fullName).trim());
        if (values.gender)
            user.setGender(String(values.gender));
        if (values.email)
            user.setEmail(String(values.email).trim());
        if (values.mobile)
            user.setMobile(String(values.mobile).trim());
        if (values.secondaryPhone != null && String(values.secondaryPhone).trim()) {
            user.setHomePhone(String(values.secondaryPhone).trim());
        }
        if (values.address)
            user.setAddress(String(values.address).trim());
        if (values.password)
            user.setPassword(String(values.password));
        if (values.passwordConfirmation) {
            user.setPasswordConfirmation(String(values.passwordConfirmation));
        }
        var birthdate = values.birthdate;
        if ((_a = birthdate === null || birthdate === void 0 ? void 0 : birthdate.isValid) === null || _a === void 0 ? void 0 : _a.call(birthdate)) {
            user.setBirthDay(birthdate.toDate());
        }
        if (values.nationalId)
            doctor.setNationalId(String(values.nationalId).trim());
        if (values.maritalStatus) {
            doctor.setMartialStatusId(String(values.maritalStatus));
        }
        if (values.specialization != null && specializations) {
            var specialization = specializations.find(function (item) { return item.getId() === Number(values.specialization); });
            if (specialization)
                doctor.setSpecialization(specialization);
        }
        doctor.setUser(user);
    };
    var submit = function () {
        setDisabled(true);
        syncModelsFromForm();
        createDoctor({
            doctor: doctor,
            successMessage: t('doctorCreated')
        });
    };
    useEffect(function () {
        if (requestStatus === 'error') {
            setDisabled(false);
        }
    }, [requestStatus]);
    var scrollToFirstError = function () {
        form.scrollToField('fullName', { behavior: 'smooth' });
    };
    return (_jsxs("div", { className: "doctor-form-page", children: [_jsxs("header", { className: "doctor-form-page__header", children: [_jsxs("nav", { className: "doctor-form-page__breadcrumb", "aria-label": "Breadcrumb", children: [_jsx("span", { className: "doctor-form-page__crumb doctor-form-page__crumb--muted", children: t('breadcrumbPeople') }), _jsx(ChevronRight, { size: 13, strokeWidth: 2, "aria-hidden": true }), _jsx(Link, { to: "/doctors", className: "doctor-form-page__crumb", children: t('breadcrumbDoctors') }), _jsx(ChevronRight, { size: 13, strokeWidth: 2, "aria-hidden": true }), _jsx("span", { className: "doctor-form-page__crumb doctor-form-page__crumb--current", children: t('breadcrumbNew') })] }), _jsxs("div", { className: "doctor-form-page__title-row", children: [_jsx("button", { type: "button", className: "doctor-form-page__back", onClick: function () { return navigate('/doctors'); }, "aria-label": t('common:buttons.cancel'), children: _jsx(ArrowLeft, { size: 18, strokeWidth: 2 }) }), _jsx("h1", { className: "doctor-form-page__title", children: t('title') })] })] }), _jsx("div", { className: "doctor-form-page__canvas", children: _jsxs(Form, { className: "doctor-form", layout: "vertical", form: form, onFinish: submit, onFinishFailed: scrollToFirstError, requiredMark: false, children: [_jsx(PersonalInfoForm, { doctor: doctor, user: user }), specializations ? (_jsx(ClinicalDetailsForm, { doctor: doctor, user: user, specializations: specializations })) : null, _jsx(CredentialsForm, { user: user }), _jsxs("div", { className: "doctor-form-page__footer", children: [_jsxs("p", { className: "doctor-form-page__hint", children: [_jsx("span", { children: "*" }), " ", t('requiredHint')] }), _jsxs("div", { className: "doctor-form-page__footer-actions", children: [_jsx("button", { type: "button", className: "doctor-form-page__btn doctor-form-page__btn--ghost", onClick: function () { return navigate('/doctors'); }, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "doctor-form-page__btn doctor-form-page__btn--primary", disabled: disabled, children: [_jsx(Check, { size: 16, strokeWidth: 2 }), _jsx("span", { children: t('save') })] })] })] })] }) })] }));
};
export default localeTranslator(NewDoctor, 'doctorForm');
